<h3 class="title configurator-title">{{ 'closet-doors-custom.suppliers.title' | translate }}</h3>
<div class="config-container shadow" *ngIf="doorRangesGroup != null && doorRangesGroup.length > 0">
  <h4 class="title configurator-subtitle">{{ 'closet-doors-custom.suppliers.suppliers' | translate }}</h4>

  <div class="supplier-container">
    <div
      class="config-container shadow"
      [ngClass]="{ active: isSupplierSelected(group.supplier.id) }"
      *ngFor="let group of doorRangesGroup"
      (click)="selectSupplier(group)">
      <ng-casto-img-loader
        [imgSrc]="baseImgURL + group.supplier.icon.path"
        [imgClass]="'card-img'"></ng-casto-img-loader>
    </div>
    <ng-casto-loader *ngIf="!doorRangesGroup"></ng-casto-loader>
  </div>

  <div
    class="supplier-info"
    [ngClass]="{
      'd-none': !isSupplierSelected(group.supplier.id),
    }"
    id="supplier-info-{{ group.supplier.id }}"
    *ngFor="let group of doorRangesGroup">
    <div class="supplier-info-icon">
      <svg>
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-action-zoom"></use>
      </svg>
    </div>

    <div class="supplier-info-container">
      <h6 class="supplier-info-title" *ngIf="currentLang === 'fr'">
        <i
          ><strong class="more-infos">{{ 'decking-boards.environment.most-infos' | translate }}</strong> -
          <strong>{{ group.supplier.tooltip.titleFr }}</strong></i
        >
      </h6>
      <h6 class="supplier-info-title" *ngIf="currentLang === 'en'">
        <i
          ><strong class="more-infos">{{ 'decking-boards.environment.most-infos' | translate }}</strong> -
          <strong>{{ group.supplier.tooltip.titleEn }}</strong></i
        >
      </h6>
      <p class="terrain-info-description" *ngIf="currentLang === 'fr'">{{ group.supplier.tooltip.descriptionFr }}</p>
      <p class="terrain-info-description" *ngIf="currentLang === 'en'">{{ group.supplier.tooltip.descriptionEn }}</p>
    </div>

    <img
      *ngIf="group.supplier.tooltip.icon"
      src="{{ baseImgURL + group.supplier.tooltip.icon.path }}"
      alt="terrain-info-img"
      class="location-info-image" />
  </div>

  <br />
  <div *ngIf="configurationHasSupplier()">
    <h4 class="title configurator-subtitle">{{ 'closet-doors-custom.suppliers.doorRanges' | translate }}</h4>
    <span class="disabled-product pt-1 ml-4" *ngIf="!configuration.hasValidQuotation && !isDoorRangeValid()">
      {{ 'closet-doors-custom.finishes.disable-message' | translate }}
    </span>
    <span
      class="disabled-with-quotation-product pt-1 ml-4"
      *ngIf="configuration.hasValidQuotation && !isDoorRangeValid()">
      {{ 'closet-doors-custom.finishes.valid-quotation-message' | translate }}
    </span>
    <div class="doorRange-cards-container">
      <div
        class="doorRange-card"
        [ngClass]="{ active: isDoorRangeSelected(range.id), disabled: range.isDisabled }"
        *ngFor="let range of doorRanges"
        (click)="selectDoorRange(range)">
        <ng-casto-img-loader [imgSrc]="baseImgURL + range.icon.path" [imgClass]="'doorRange-img'"></ng-casto-img-loader>
        <p class="doorRange-card-title">{{ range.name }}</p>
      </div>
    </div>
  </div>
</div>

<div class="config-container shadow" *ngIf="!doorRangesGroup">
  <ng-casto-loader></ng-casto-loader>
</div>
